import { JumpToModule } from './../../../widgets/jump-to/jump-to.module';
import { TaskPopupModule } from './../../task/task-popup/task-popup.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxDataGridModule, DxChartModule, DxTextAreaModule, DxRangeSelectorModule, DxButtonModule, DxPopupModule, DxDropDownButtonModule, DxSwitchModule } from 'devextreme-angular';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';
import { StatisticalForecastingDeepDiveRoutingModule } from './statistical-forecasting-deep-dive-routing.module';
import { StatisticalForecastingDeepDiveComponent } from './statistical-forecasting-deep-dive.component';
import { SharedModule } from 'src/app/pipes/shared-module';
import { TaskListPopupModule } from '../../task/task-list-popup/task-list-popup.module';
import { BookmarkModule } from 'src/app/widgets/bookmark/bookmark.module';
import { DxTableControllerDirective } from 'src/app/directives/dx-table-controller.directive';

@NgModule({
	declarations: [ StatisticalForecastingDeepDiveComponent ],
	imports: [
		CommonModule,

		JumpToModule,

		DxChartModule,
		DxDropDownButtonModule,
		DxTextAreaModule, DxRangeSelectorModule,
		DxDataGridModule,
		DevEpressCommonModule,
		StatisticalForecastingDeepDiveRoutingModule, SharedModule,
		DxButtonModule, DxPopupModule, DxSwitchModule,
		TaskPopupModule, TaskListPopupModule, BookmarkModule,
		DxTableControllerDirective,
	]
})
export class StatisticalForecastingDeepDiveModule { }
